import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import FormError from "../../components/forms/FormError";

class RenameAccountForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="New Account Name"
              name="name"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RenameAccountForm"
})(RenameAccountForm);

export default ReduxForm;